import { style, animate, trigger, transition } from '@angular/animations';

export const splashScreenAni = trigger('splashScreen', [
    transition(':leave', [
        style({ opacity: 1 }),
        animate(
            '500ms 300ms ease-out',
            style({ opacity: 0 }))
    ])
])